"use strict";

(function () {
  "use strict";

  angular.module("courses", ["ui.router", "common", "course.selectionElearnings"]);
})();